import { IDeviceConfig } from "../../../APIRequests/APIPut"
import { DeviceFormConfig } from "../../DevicePage"
import DevicePage from "../../DevicePage"

interface DeviceTabComponentProps {
  deviceConfig: IDeviceConfig
  saveConfig: (config: IDeviceConfig) => void
  configSchema: { [p: string]: any } | undefined
}

export default function Sensors({
  deviceConfig,
  saveConfig,
  configSchema,
}: DeviceTabComponentProps) {
  const formConfig: DeviceFormConfig = {
    Temperature: [
      "temp.enable",
      "temp.lowlim",
      "temp.highlim",
      "temp.prio",
      "temp.schedule.station",
    ],
    Humidity: [
      "hum.enable",
      "hum.lowlim",
      "hum.highlim",
      "hum.prio",
      "hum.schedule.station",
    ],
    Gas: [
      "gas.enable",
      "gas.lowlim",
      "gas.highlim",
      "gas.prio",
      "gas.schedule.station",
    ],
    Pressure: [
      "press.enable",
      // "press.lowlim",
      // "press.highlim",
      "press.prio",
      "press.schedule.station",
    ],
  }

  return (
    <DevicePage
      deviceConfig={deviceConfig}
      saveConfig={saveConfig}
      configSchema={configSchema}
      formConfig={formConfig}
    />
  )
}
